import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.classList.remove("tw-hidden")
  }

  close() {
    this.dialogTarget.classList.add("tw-hidden")
  }
}
